// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { KEYBOARD_NAV_DATA_ID, KEYBOARD_NAV_DATA_LEVEL } from '@progress/kendo-vue-data-tools';
import { noop } from '@progress/kendo-vue-common';
/**
 * @hidden
 */

var GridDetailHierarchyCellVue2 = {
  props: {
    id: String
  },
  inject: {
    getKeyboardNavigationAttributes: {
      default: noop
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoIntlService = inject('kendoIntlService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var navAttrs = this.getKeyboardNavigationAttributes(this.$props.id);
    return h("td", {
      "class": "k-hierarchy-cell",
      tabindex: navAttrs.tabIndex,
      attrs: this.v3 ? undefined : {
        tabindex: navAttrs.tabIndex,
        "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
        "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
      },
      "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
      "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
    });
  }
};
/**
 * @hidden
 */

var GridDetailHierarchyCell = GridDetailHierarchyCellVue2;
export { GridDetailHierarchyCell, GridDetailHierarchyCellVue2 };